import type { GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersId200 } from '@fukuri-admins/apis/client/gen/model';
import type { EditClientAdminUserFormFieldValues } from '../schema';

type IConvertToFormValues = (
  data: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersId200
) => EditClientAdminUserFormFieldValues;

/**
 * API レスポンスを企業管理者編集フォームの初期値に変換する
 */
export const convertToFormValues: IConvertToFormValues = data => {
  const { client_admin_user } = data;
  return {
    fullName: client_admin_user.full_name,
    email: client_admin_user.email,
    password: '',
    passwordConfirmation: '',
  };
};
